export const AgeFilter = {
  LOW: 55,
  MID: '55 - 65',
  HIGHT: 65,
} as const;
